import { inject, RESPONSE_INIT } from '@angular/core'
import { ResolveFn, Router } from '@angular/router'
import { map, catchError } from 'rxjs'
import { CustomContent } from '../services/custom-content/custom-content'

export const pageContentResolver: ResolveFn<boolean> = (route, state) => {
	const response = inject(RESPONSE_INIT)
	const router = inject(Router)
	const customContentService = inject(CustomContent)

	let currentPath = route.url.map((segment) => segment.path).join('/')
  
	if (state.url === '/') {
		currentPath = 'home'
	}

	return customContentService.getPageContent(currentPath).pipe(
		map((resp) => resp),
		catchError((error) => {
			// Here we are catching the error from the content service and setting the response to the server as a 404.
			// This allows us to return a 404 status code for the page while still rendering the Angular application, which can then display a custom 404 page to the user.
			if (error.status === 404 && response) {
				response.status = 404
				response.statusText = error.statusText || 'Not Found'
			}

			return router.navigate(['/404'], { skipLocationChange: true })
		}),
	)
}
